import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
//import { useSnackbar } from "notistack";
import { Paper } from "@material-ui/core";
import { getProjectInforme1 } from "../../services/projectFileServices";
import "react-dropzone-uploader/dist/styles.css";

const PanelFilesInforme1I = ({ projectSlug }) => {
  //const apiEndPoint = process.env.REACT_APP_API_URL;
  //const { enqueueSnackbar } = useSnackbar();

  //Informe

  let [informe11, setInforme11] = useState(null);
  let [informe12, setInforme12] = useState(null);
  let [informe13, setInforme13] = useState(null);
  let [informe14, setInforme14] = useState(null);
  let [informe15, setInforme15] = useState(null);
  let [informe16, setInforme16] = useState(null);
  let [informe17, setInforme17] = useState(null);
  let [informe18, setInforme18] = useState(null);
  let [informe19, setInforme19] = useState(null);
  let [informe110, setInforme110] = useState(null);

  // called every time a file's `status` changes

  const handleOpenPDF1 = (event) => {
    event.preventDefault();
    if (informe11 !== null) window.open(informe11);
  };

  const handleOpenPDF2 = (event) => {
    event.preventDefault();
    if (informe12 !== null) window.open(informe12);
  };

  const handleOpenPDF3 = (event) => {
    event.preventDefault();
    if (informe13 !== null) window.open(informe13);
  };
  const handleOpenPDF4 = (event) => {
    event.preventDefault();
    if (informe14 !== null) window.open(informe14);
  };
  const handleOpenPDF5 = (event) => {
    event.preventDefault();
    if (informe15 !== null) window.open(informe15);
  };
  const handleOpenPDF6 = (event) => {
    event.preventDefault();
    if (informe16 !== null) window.open(informe16);
  };
  const handleOpenPDF7 = (event) => {
    event.preventDefault();
    if (informe17 !== null) window.open(informe17);
  };
  const handleOpenPDF8 = (event) => {
    event.preventDefault();
    if (informe18 !== null) window.open(informe18);
  };
  const handleOpenPDF9 = (event) => {
    event.preventDefault();
    if (informe19 !== null) window.open(informe19);
  };
  const handleOpenPDF10 = (event) => {
    event.preventDefault();
    if (informe110 !== null) window.open(informe110);
  };

  useEffect(() => {
    const populateinforme1 = async () => {
      const { data: project } = await getProjectInforme1(projectSlug);
      //setInforme1(project.informe1);
      setInforme11(project.informe11);
      setInforme12(project.informe12);
      setInforme13(project.informe13);
      setInforme14(project.informe14);
      setInforme15(project.informe15);
      setInforme16(project.informe16);
      setInforme17(project.informe17);
      setInforme18(project.informe18);
      setInforme19(project.informe19);
      setInforme110(project.informe110);
    };

    populateinforme1();
  }, [projectSlug]);

  return (
    <>
      <Paper className="paper">
        <h2>Informe Semestral (Enero - Julio): </h2>

        {informe11 === null ? (
          " No existe ningun archivo  "
        ) : (
          <Link to="#" onClick={handleOpenPDF1}>
            {informe11 === null
              ? "No existe ningun archivo "
              : "Abrir Informe 1"}
          </Link>
        )}
        <small style={{ color: "white" }}>
          {" "}
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{" "}
        </small>

        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>

        {informe12 === null ? (
          "  "
        ) : (
          <Link to="#" onClick={handleOpenPDF2}>
            {informe12 === null ? "  " : "Abrir Informe 2"}
          </Link>
        )}

        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>

        {informe13 === null ? (
          " "
        ) : (
          <Link to="#" onClick={handleOpenPDF3}>
            {informe13 === null ? "  " : "Abrir Informe 3"}
          </Link>
        )}

        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>

        {informe14 === null ? (
          " "
        ) : (
          <Link to="#" onClick={handleOpenPDF4}>
            {informe14 === null ? "  " : "Abrir Informe 4"}
          </Link>
        )}
        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>

        {informe15 === null ? (
          " "
        ) : (
          <Link to="#" onClick={handleOpenPDF5}>
            {informe15 === null ? "  " : "Abrir Informe 5"}
          </Link>
        )}
        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>

        {informe16 === null ? (
          " "
        ) : (
          <Link to="#" onClick={handleOpenPDF6}>
            {informe16 === null ? "  " : "Abrir Informe 6"}
          </Link>
        )}
        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>

        {informe17 === null ? (
          " "
        ) : (
          <Link to="#" onClick={handleOpenPDF7}>
            {informe17 === null ? "  " : "Abrir Informe 7"}
          </Link>
        )}
        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>

        {informe18 === null ? (
          " "
        ) : (
          <Link to="#" onClick={handleOpenPDF8}>
            {informe18 === null ? "  " : "Abrir Informe 8"}
          </Link>
        )}
        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>

        {informe19 === null ? (
          " "
        ) : (
          <Link to="#" onClick={handleOpenPDF9}>
            {informe19 === null ? " " : "Abrir Informe 9"}
          </Link>
        )}
        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>

        {informe110 === null ? (
          " "
        ) : (
          <Link to="#" onClick={handleOpenPDF10}>
            {informe110 === null ? "  " : "Abrir Informe 10"}
          </Link>
        )}
        <small style={{ color: "white" }}>
          {" "}
          <br />{" "}
        </small>
      </Paper>
    </>
  );
};

export default PanelFilesInforme1I;
